import {
  AppActionTypes,
  UpdateUserLoaded,
  GetNotifications,
  DeletePolicyNotificationsLoaded,
} from '../redux/actions';
import { Types as PolicyTypes } from '../redux/actions/policy';
import { Types as AdviserTypes } from '../redux/actions/adviser-actions';
import { Types as InvitationTypes } from '../redux/actions/invitation-actions';
import { Types as PaymentTypes } from '../redux/actions/payment-actions';
import { PolicyStatus } from 'constants/policy';
import { IPolicy, IUser } from 'types';

const createPolicyScanSideEffect = (dispatch, user: IUser) => {
  dispatch(GetNotifications());
  if (!user.hasPolicyScan) {
    dispatch(UpdateUserLoaded(R.assoc('hasPolicyScan', true, user)));
  }
};

const getAdviceSideEffect = (dispatch, user: IUser) => {
  if (!user.hasGetAdvice) {
    dispatch(UpdateUserLoaded(R.assoc('hasGetAdvice', true, user)));
  }
};

const createPolicySideEffect = (dispatch, user: IUser, policy: IPolicy) => {
  if (policy.status !== PolicyStatus.MARKET_SCAN_DRAFT) {
    dispatch(GetNotifications());
  }
  if (!user.hasPolicy) {
    dispatch(UpdateUserLoaded(R.assoc('hasPolicy', true, user)));
  }
};

const createInvitationSideEffect = (dispatch) => {
  dispatch(GetNotifications());
};

const deletePolicySideEffect = (dispatch, id: string) => {
  dispatch(DeletePolicyNotificationsLoaded(id));
};

const sideEffectMiddleware = (store) => (next) => (action: AppActionTypes) => {
  const { user } = store.getState();

  switch (action.type) {
    case AdviserTypes.CREATE_ADVISER_CONNECT:
      getAdviceSideEffect(store.dispatch, user);
      break;
    case PolicyTypes.CREATE_POLICY_BUNDLE_LOADED:
    case PolicyTypes.CREATE_POLICY_LOADED:
      createPolicySideEffect(store.dispatch, user, action.data);
      break;
    case PolicyTypes.CREATE_POLICY_SCAN_LOADED:
      createPolicyScanSideEffect(store.dispatch, user);
      break;
    case PolicyTypes.CREATE_POLICY_SCAN_WITHOUT_POLICY_LOADED:
      createPolicyScanSideEffect(store.dispatch, user);
      break;
    case InvitationTypes.CREATE_INVITATION_LOADED:
      createInvitationSideEffect(store.dispatch);
      break;
    case PolicyTypes.DELETE_POLICY_LOADED:
      deletePolicySideEffect(store.dispatch, action.data);
      break;
    default:
      break;
  }

  return next(action);
};

export default sideEffectMiddleware;
